import React, { Component } from 'react';
import * as openBetsService from '../../services/openBetsService'
import * as dateUtil from '../../util/date.util'
import Currency from './currency'
import * as authUtil from "../../util/auth.util";
export default class UnsetteledBetsPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accounts: "",
            orders: [],
            last_id: "",
            first_id: "",
            action: "",
            from: "",
            to: "",
            page_no: 1,
            count_records: 0,
            records_per_page: 25,
            loader: false,
        };
    }
    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            authUtil.logout();
        }
        let curDate = new Date().toISOString().split('T')[0]
        let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
        this.setState({ accounts: userData.sub, to: curDate, from: weekDate, orders: [] }, () => { this.submitForm() })
    }
    parseFilterBody() {
        // let body = {
        //     "filters": {
        //         "accounts": this.state.accounts,
        //         "amount_from": 0.0,
        //         "amount_to": 0.0,
        //         "betstatus": ["PLACED"]
        //     },
        //     "last_id": this.state.last_id,
        //     "first_id": this.state.first_id,
        //     "action": this.state.action,
        //     "from": "",
        //     "to": "",
        //     "page_no": this.state.page_no,
        //     "records_per_page": 25,
        //     "count_records": this.state.count_records,
        // }
        let body = {
            "lastId": this.state.last_id,
            "firstId": this.state.first_id,
            "action": this.state.action,
            "from": "",
            "to": "",
            "pageNo": this.state.page_no,
            "recordsPerPage": 25
        }
        body = this.clean(body);
        return body
    }
    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        this.setState({ orders: [], loader: true })
        await openBetsService.postOpenBets(body).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        orders: res.items,
                        last_id: res.lastId,
                        first_id: res.firstId,
                        action: res.action,
                        page_no: res.pageNo,
                        records_per_page: res.recordsPerPage,
                        count_records: res.countRecords,
                        loader: false
                    }
                );
            } else {
                this.setState({ orders: [], loader: false })
            }
        })
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    onAction(e) {
        const value = e.target.name;
        let page_n = 0;
        if (value === "next") {
            page_n = this.state.page_no + 1;
        }
        if (value === "prev") {
            page_n = this.state.page_no - 1;
        }
        this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 31) {
            this.props.notify("Date range must be 1 month.", "error")
        }
        else {
            this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
        }
    }
    render() {
        let page_no = parseInt(this.state.page_no)
        let count_records = parseInt(this.state.count_records)
        let records_per_page = parseInt(this.state.records_per_page)
        let current_record = 0
        let total_record = 0
        if (count_records > (records_per_page * page_no)) {
            current_record = records_per_page
            total_record = count_records
        } else {
            current_record = count_records - ((page_no - 1) * records_per_page)
            total_record = count_records
        }
        return (
            <>
                <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0" id="myModalLabel">Unsetteled Bets</h5><button onClick={() => { this.props.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table id="basic-btn" className="table  table-bordered font-12 table-sm">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th className="wid150 pthead">Competition</th>
                                                <th className="wid280 pthead">Event</th>
                                                <th className="wid150 pthead">Market</th>
                                                <th className="wid140 pthead">Runner</th>
                                                <th className="wid100 pthead">Side</th>
                                                <th className="wid100 text-right pthead">Line</th>
                                                <th className="wid100 text-right pthead">Rate</th>
                                                <th className="wid100 text-right pthead">Amount</th>
                                                <th title="Potential Profit" className="wid100 text-right pthead">PP</th>
                                                <th title="Potential Loss" className="wid100 text-right pthead">PL</th>
                                                <th className="wid140 pthead">Status</th>
                                                <th className="wid165 pthead">Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!this.state.loader ?
                                                <tr>
                                                    <td colSpan={17} className="text-center py-5">
                                                        <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                    </td>
                                                </tr> :
                                                this.state.orders.length > 0 ? this.state.orders.map((order, i) => {
                                                    let st = (order.createdAt).split(" ")
                                                    let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                    let dt = new Date(dtstr).toLocaleString("en-IN")
                                                    let price = order.price
                                                    let competitionName = !!order.competitionName ? order.competitionName : "-"
                                                    if(order.eventTypeId === '300'){
                                                        order.marketTime =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                        if(competitionName !== '-'){
                                                        competitionName = dateUtil.getBinaryCompetitionDisplayName(order.competitionName)
                                                        }
                                                    }
                                                    return (
                                                        <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                            <td>{competitionName}</td>
                                                            <td>{!!order.eventName ? order.eventName : "-"}</td>
                                                            <td>{order.eventTypeId === '300' && !!order.marketTime && order.marketTime.length > 0 ? 
                                                            <>
                                                            {order.marketTime[0] }
                                                            <span className=''> [<b>{(order.marketTime.length > 0 ? order.marketTime[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                            <td>{!!order.runnerName ? order.runnerName : "-"}</td>
                                                            <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                            <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                            <td className="text-right fbold">{!!price ? price : "-"}</td>
                                                            <td className="text-right fbold">{!!order.amount ? <Currency classPropName={"fbold"} amount={order.amount} showColor={false} /> : "0"}</td>
                                                            {order.eventTypeId !== "99" ?
                                                            <td className="text-right fbold">{!!order.potentialProfit ? <Currency classPropName={"fbold"} amount={order.potentialProfit} showColor={true} /> : "0"}</td>
                                                            : <td className="text-right">{order.provider === 'LUDOCRICKET' ? <Currency classPropName={order.betStatus === "WON" ? "text-success fbold" : order.betStatus === "LOST" ? "text-danger fbold" : "fbold"} amount={order.potentialProfit} showColor={false} /> : '-'}</td>
                                                            }
                                                            {order.eventTypeId !== "99" ?
                                                            <td className="text-right fbold">{!!order.potentialLoss ? <Currency classPropName={"fbold"} amount={order.potentialLoss} showColor={true} /> : "0"}</td>
                                                            : <td className="text-right">-</td>
                                                            }
                                                            <td>{!!order.betStatus ? order.betStatus : "-"}</td>
                                                            <td>{dt ? dt : "-"}</td>
                                                        </tr>
                                                    );
                                                }) : <tr>
                                                    <td colSpan={15} align="center">
                                                        No Data Found.
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="row w-100">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {current_record} of {total_record} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                        <div className="btn-group d-inline mr-2" role="group" aria-label="Basic example" id="divpagecount">
                                            <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" ? true : false}>Prev</button>
                                            <button className="btn btn-blue" disabled>
                                                {
                                                    this.state.page_no
                                                }
                                            </button>
                                            <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" ? true : false}>Next</button>
                                        </div>
                                        <button type="button" onClick={() => { this.props.hidePopup() }} className="btn btn-outline-danger waves-effect mx-auto d-inline" data-dismiss="modal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div>
                </div>
            </>
        )
    }
}
